<div class="echarts" echarts [options]="chartOption" *ngIf="pieChartData?.pieData?.length else noData"></div>
<ng-template #noData>
    <div class="place-center h-100 no-data-style">No Data</div>
</ng-template>